import { Auth } from "aws-amplify";
import { hostOf, track } from "@seller-hermes/app/telemetry";
import {
  PortalProductLink,
  PortalProductType,
  PortalSellerGroupContext,
} from "./portal.types";

export const PORTAL_PRODUCT_LABELS: Record<PortalProductType, string> = {
  INSIGHTS: "Insights",
  ROUTING: "Roteirizador",
  VENANCIO_CTE_RECON: "Venancio CT-e",
};

export const getPortalProductLabel = (link: PortalProductLink): string =>
  PORTAL_PRODUCT_LABELS[link.product] ?? link.product;

export const buildPortalProductHandoffUrl = (
  idToken: string,
  context: PortalSellerGroupContext,
  link: PortalProductLink,
): string => {
  const baseUrl = link.url.replace(/\/+$/, "");
  return `${baseUrl}/auth/callback#id_token=${idToken}&seller_group_id=${context.id}`;
};

// O portal já detém a sessão Cognito (cookieStorage compartilhado), então
// entrega o id_token direto ao callback do produto — 1 redirect, sem bounce
// pelo /login do dashboard. O seller_group_id no fragment garante que o
// produto assine a sessão para o card clicado, não para o SG default.
export const openPortalProduct = async (
  context: PortalSellerGroupContext,
  link: PortalProductLink,
): Promise<void> => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();
    track({
      name: "portal_product_redirect",
      product: link.product,
      handoff: "id_token",
      target_host: hostOf(link.url),
    });
    window.location.href = buildPortalProductHandoffUrl(idToken, context, link);
  } catch {
    track({
      name: "portal_product_redirect",
      product: link.product,
      handoff: "no_session",
      target_host: hostOf(link.url),
    });
    // Sem sessão Cognito válida: navega para o produto e deixa o bounce
    // padrão de login (redirect_uri) acontecer.
    window.location.href = link.url;
  }
};
